import { render } from "./InventoryHome.vue?vue&type=template&id=fce2b50c&scoped=true"
import script from "./InventoryHome.vue?vue&type=script&lang=js"
export * from "./InventoryHome.vue?vue&type=script&lang=js"

import "./InventoryHome.vue?vue&type=style&index=0&id=fce2b50c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce2b50c"]])

export default __exports__